import InteractiveMap from './components/interactiveMapV2';
import './style.scss';

const TienIchPage = () => {
  return (
    <div className="tien-ich-page">
      <InteractiveMap />
    </div>
  );
};

export default TienIchPage;
